export default __webpack_public_path__ + "static/freestar-c3d1e7e1ee65a0768a40b52a7b740448.svg";